import {useTranslation} from '@/translations/i18n.tsx'
import {useMemo} from 'react'
import {Assignment} from '@features/assignment/types.ts'
import {ButtonLink} from '@components/commons/button-link'
import {differenceInHours} from 'date-fns'
import {parseDate} from '@/dates.ts'
import {Tooltip} from '@components/ui/tooltip'

export const WalkthroughFormButton = ({assignment}: {assignment: Assignment}) => {
    const {t} = useTranslation()

    const isDisabledButton = useMemo(() => {
        if (!assignment.to_shoot_at) {
            return false
        }

        const toShootAt = parseDate(assignment.to_shoot_at)
        // Calculate the time difference in hours
        const hoursUntilAssignment = differenceInHours(toShootAt, new Date())

        return hoursUntilAssignment > 24
    }, [assignment.to_shoot_at])

    return (
        <Tooltip
            content={isDisabledButton && t('assignment:descriptions:upload_assets_info_walkthrough')}
            variant="light"
            rootProps={{open: isDisabledButton ? false : undefined}}
            contentProps={{side: 'bottom'}}
        >
            <ButtonLink
                variant="primary"
                disabled={isDisabledButton}
                target="_blank"
                to={`https://my.propertyinspect.com/tasks/${assignment.task.inspection_id}`}
            >
                {t('single_shooting:goto_walkthrough_form')}
            </ButtonLink>
        </Tooltip>
    )
}
